export const SPORT_PRIORITIES_MAP = {
  'sr:sport:21': 100, // Cricket
  'sr:sport:1': 90, // Soccer
  'sr:sport:5': 80, // Tennis
  'sr:sport:2': 70, // Basketball
  'sr:sport:3': 60, // Baseball
  'sr:sport:20': 50, // Table tennis
};
